import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  FaRegCircleUser,
  FaUsers,
  FaBoxOpen,
  FaJediOrder,
  FaBars,
  FaXmark,
} from "react-icons/fa6";
import { Link, Outlet, useNavigate } from "react-router-dom";
import ROLE from "../common/role";
import "../App.css";
import { FaHome } from "react-icons/fa";

const AdminPanel = () => {
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (user?.role !== ROLE.ADMIN) {
      navigate("/");
    }
  }, [user, navigate]);

  const handleHomeClick = (e) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  const confirmNavigation = () => {
    setShowConfirm(false);
    navigate("/");
  };

  const cancelNavigation = () => {
    setShowConfirm(false);
  };

  return (
    <div className="admin-panel-container">
      {/* Top bar visible only on small devices */}
      <div className="mobile-header">
        <button
          className="hamburger-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <FaXmark size={22} /> : <FaBars size={22} />}
        </button>
        <h2 className="mobile-title">Fashionfy Admin</h2>
      </div>

      {/* Sidebar */}
      <aside className={`sidebar ${isMenuOpen ? "open" : ""}`}>
        <div className="logo-section">
          <h1 className="brand-heading">Admin Panel</h1>
          <p className="logo-description">
            Welcome to <strong>Imran & Sons Traders</strong> Admin Panel. Manage your store
            efficiently and effectively with our intuitive tools and features.
          </p>
        </div>

        <div className="profile-section">
          <div className="profile-pic-container">
            {user?.profilePic ? (
              <img
                src={
                  user.profilePic.startsWith("http")
                    ? user.profilePic
                    : `https://dates-website-backend.vercel.app/${user.profilePic}`
                }
                alt={user?.name || "User"}
                className="profile-pic w-12 h-12 rounded-full object-cover border-2 border-blue-200"
              />
            ) : (
              <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center">
                <FaRegCircleUser className="w-6 h-6 text-gray-600" />
              </div>
            )}
          </div>

          <p className="profile-name">{user?.name}</p>
          <p className="profile-role">{user?.role}</p>
        </div>

        <nav className="nav-menu">
          <Link
            to="all-users"
            className="nav-link"
            onClick={() => setIsMenuOpen(false)}
          >
            <FaUsers /> Manage Users
          </Link>
          <Link
            to="all-products"
            className="nav-link"
            onClick={() => setIsMenuOpen(false)}
          >
            <FaBoxOpen /> Manage Products
          </Link>
          <Link
            to="manage-orders"
            className="nav-link"
            onClick={() => setIsMenuOpen(false)}
          >
            <FaJediOrder /> Manage Orders
          </Link>
          <Link
            to="/"
            className="nav-link"
            onClick={(e) => {
              handleHomeClick(e);
              setIsMenuOpen(false);
            }}
          >
            <FaHome /> Home
          </Link>
        </nav>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>

      {/* Custom Confirmation Modal */}
      {showConfirm && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <h2>Confirm Navigation</h2>
            <p>
              Are you sure you want to leave the admin panel and go to the Home
              page?
            </p>
            <div className="modal-buttons">
              <button className="btn-cancel" onClick={cancelNavigation}>
                Cancel
              </button>
              <button className="btn-confirm" onClick={confirmNavigation}>
                Yes, Go Home
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
